import { AccountPayableTabHash } from 'constants/AccountPayableStatusCategories'
import {
  AccountPayableRecordStatus,
  AccountsPayableRecordCategory,
} from 'generated/graphql'

interface IAccountPayableRecordBatchState {
  category?: AccountsPayableRecordCategory | null
  status?: AccountPayableRecordStatus | null
  payedExternally?: boolean | null
  bookingInvoiceBatchLine?: { batchId?: number | string | null } | null
}

// Telleroo and HedgeFlows records that can be paid or already were paid, but have no batch.
// Records marked as paid externally never get a batch, so they are left out.
export const isUnbatchedRecord = (record?: IAccountPayableRecordBatchState | null): boolean => {
  const unbatchedCategories = [
    AccountsPayableRecordCategory.Telleroo,
    AccountsPayableRecordCategory.HedgeFlows,
  ]

  const unbatchedStatuses = [
    AccountPayableRecordStatus.ScheduledPayment,
    AccountPayableRecordStatus.PaymentFailed,
    AccountPayableRecordStatus.Archived,
  ]

  return (
    !record?.bookingInvoiceBatchLine &&
    !record?.payedExternally &&
    !!record?.category &&
    unbatchedCategories.includes(record.category) &&
    !!record?.status &&
    unbatchedStatuses.includes(record.status)
  )
}

// Mirrors the server rule: SmartPay records are batched from Archived, all others from Scheduled Payment.
export const isBatchableStatus = (
  category?: AccountsPayableRecordCategory | null,
  status?: AccountPayableRecordStatus | null,
): boolean =>
  category === AccountsPayableRecordCategory.SmartPay
    ? status === AccountPayableRecordStatus.Archived
    : status === AccountPayableRecordStatus.ScheduledPayment

// The "Not batched" filter only makes sense on tabs that can contain unbatched records.
export const isNotBatchedFilterTab = (tabHash?: string | null): boolean => {
  const notBatchedTabs: Array<string> = [
    AccountPayableTabHash.All,
    AccountPayableTabHash.ScheduledPayment,
    AccountPayableTabHash.PaymentFailed,
    AccountPayableTabHash.Archive,
  ]

  return !!tabHash && notBatchedTabs.includes(tabHash.replace('#', ''))
}
